import { useMutation, useQueryClient } from '@tanstack/react-query'

import { movePhrasesBulk } from '../api'
import { contentKeys } from '../queryKeys'

const useBulkMovePhraseMutation = (selectedNodeId: string) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: movePhrasesBulk,
    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: contentKeys.phrases(selectedNodeId),
      })
    },
  })
}

export default useBulkMovePhraseMutation
